import React from "react";
import {
  PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer
} from "recharts";
import { useTranslation } from "react-i18next";

const COLORS = ["#689f38", "#eb1418", "#90a4ae"];

const WinLossDrawChart = ({ gameInfos }) => {
  const { t } = useTranslation();

  const winLossCounts = { Win: 0, Lose: 0, Draw: 0 };

  gameInfos.forEach((game) => {
    const color = (game.color || "").toLowerCase();
    const winnerColor = (game.winnerColor || "").toLowerCase();

    if (winnerColor === "neutral") {
      winLossCounts.Draw += 1;
    } else if (color === winnerColor) {
      winLossCounts.Win += 1;
    } else {
      winLossCounts.Lose += 1;
    }
  });

  const chartData = [
    { name: t("chart.win"), value: winLossCounts.Win },
    { name: t("chart.lose"), value: winLossCounts.Lose },
    { name: t("chart.draw"), value: winLossCounts.Draw },
  ];

  const totalGames = chartData.reduce((sum, item) => sum + item.value, 0);

  return (
    <div
      style={{
        border: "1px solid #ccc",
        borderRadius: "8px",
        padding: "16px",
        marginBottom: "24px",
        backgroundColor: "#fff",
        boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
        width: "100%",
        maxWidth: "900px",
        margin: "0 auto",
        boxSizing: "border-box",
        position: "relative",
      }}
    >
      <h3 style={{
        marginBottom: "12px",
        fontSize: "1.25rem",
        fontWeight: "bold",
        textAlign: "center",
      }}>
        {t("chart.winLossTitle")}
      </h3>

      <div style={{ position: "relative", width: "100%", height: window.innerWidth < 600 ? "220px" : "300px" }}>
        <ResponsiveContainer>
          <PieChart>
            <Pie
              data={chartData}
              dataKey="value"
              nameKey="name"
              outerRadius={100}
              innerRadius={60}
              label
            >
              {chartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        </ResponsiveContainer>

        {/* Center label with total */}
        <div style={{
          position: "absolute",
          top: "45%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          textAlign: "center",
          fontSize: "2rem",
          fontWeight: "600",
          color: "#333"
        }}>
          {totalGames}
        </div>
      </div>
    </div>
  );
};

export default WinLossDrawChart;
